import { rootSelector } from '@/redux/root/root.selectors';
import { createSelector } from '@reduxjs/toolkit';

export const projectsRootSelector = createSelector(rootSelector, state => state.projects);
export const projectsSelector = createSelector(projectsRootSelector, state => state.data);
export const projectsLoadingSelector = createSelector(projectsRootSelector, state => state.loading);
export const projectsErrorSelector = createSelector(projectsRootSelector, state => state.error);

export const projectByIdSelector = createSelector(
  [projectsSelector, (_state: unknown, projectId: string): string => projectId],
  (projects, projectId) => (projects ?? []).find(p => p.projectId === projectId),
);
